var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',{staticClass:"registration",scopedSlots:_vm._u([{key:"banner",fn:function(){return [_c('Banner',{attrs:{"title":_vm.title,"src-desktop":require('@/assets/registration/banner.jpg'),"src-mobile":require('@/assets/registration/banner-mobile.jpg'),"no-padding":""}})]},proxy:true}])},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }